import Vue from 'vue'
import Router from 'vue-router'

import store from '../store/store.js'
import qs from 'qs'
import axios from 'axios'
import cookie from '../assets/js/cookie.js'

Vue.use(Router)

const caseRegistration=()=>import('@/components/addCase/registrationPage');

let router = new Router({
    mode: 'history',
    routes: [

      {
        path: '/',
        component: caseRegistration,
        name: 'caseRegistration',
      },

    ]
})
let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js